import React, { createContext, useState, useContext, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [usuario, setUsuario] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadUsuario = () => {
      const token = localStorage.getItem('token');
      const usuarioStorage = localStorage.getItem('usuario');

      if (token && usuarioStorage) {
        setUsuario(JSON.parse(usuarioStorage));
      }
      setLoading(false);
    };

    loadUsuario();
  }, []);

  const setSession = (user, token) => {
    localStorage.setItem('token', token);
    localStorage.setItem('usuario', JSON.stringify(user));
    setUsuario(user);
  };

  const login = async (login, senha) => {
    try {
      const response = await api.post('/auth/login', { login, senha });
      const { usuario: user, token } = response.data;

      setSession(user, token);

      return { success: true };
    } catch (error) {
      return {
        success: false,
        error: error.response.data.error || 'Erro ao fazer login',
      };
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('usuario');
    setUsuario(null);
  };

  return (
    <AuthContext.Provider value={{ usuario, login, logout, loading, setSession }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth deve ser usado dentro de AuthProvider');
  }
  return context;
};
